import { makeStyles } from '@material-ui/core/styles';
import { lendingClubPalette } from '@ui-propulsion/toolkit';
export default makeStyles(function () {
  return {
    root: {
      color: lendingClubPalette.denim[300]
    }
  };
}, {
  name: 'PdsFormHelperText'
});